import {CommonRootState} from '../types';

export const selectDavisConnectedAt = (state: CommonRootState) =>
  state.davis.link && state.davis.link.date_connected;

export const selectDavisConnected = (state: CommonRootState) =>
  state.davis.link !== null;

export const selectDavisActive = (state: CommonRootState) =>
  state.davis.link !== null && state.davis.link.account.active;
